import { render } from "./CreateResponse.vue?vue&type=template&id=978d9972&scoped=true"
import script from "./CreateResponse.vue?vue&type=script&lang=js"
export * from "./CreateResponse.vue?vue&type=script&lang=js"

import "./CreateResponse.vue?vue&type=style&index=0&id=978d9972&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978d9972"]])

export default __exports__